export default "<g>\n    <rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"2\" fill-rule=\"evenodd\" />\n</g>\n";